module.exports = __webpack_public_path__ + "media/src/images/h5p_docu_1-1ec222f425b1204b5cd63576b07699cd.png";